import ProductOffer from 'model/ProductOffer';
import { ConceptLabel, OfferLabel, ProductTitle } from '../../atoms';
import {
  ProductHeaderContainer,
  ProductTitleColumn,
} from './ProductHeader.styled';

export interface ProductHeaderProps {
  product: ProductOffer;
  isExclusiveOffer?: boolean;
}

export function ProductHeader({
  product,
  isExclusiveOffer = false,
}: ProductHeaderProps) {
  return (
    <ProductHeaderContainer className="product-header">
      <ProductTitleColumn>
        <ProductTitle>{product.longName}</ProductTitle>
        <ConceptLabel conceptName={product.conceptName} />
      </ProductTitleColumn>
      <OfferLabel offerType={isExclusiveOffer ? 4 : product.offerType} />
    </ProductHeaderContainer>
  );
}
